module.exports = __webpack_public_path__ + "static/media/tc.50b64e52.pdf";